import type { SortModel } from '../models/sort-model.model';
import { PaginatedRequest } from './pagination.model';
import { SortedRequest } from './sort.model';

enum TripLegSearchMenu {
  TODAYS_TRIPS = 'todaysTrips',
  ALL_TRIPS = 'allTrips',
  DISCUSS = 'discuss',
  REVIEW_INVOICES = 'reviewInvoices',
  UNALLOCATED_TRIPS = 'unallocatedTrips',
  ALLOCATED_TRIPS = 'allocatedTrips',
  IN_PROGRESS_TRIPS = 'inProgressTrips',
  UNATTESTED_TRIPS = 'unattestedTrips',
  INACTIVE_TRIPS = 'inactiveTrips',
  ESCALATED = 'escalated',
}

type TripLegSearchRequest = {
  clientBC?: string;
  menu?: TripLegSearchMenu;
  search?: string;
  tripLegReferenceID?: string;
  memberName?: string;
  firstName?: string;
  lastName?: string;
  clientPassengerID?: string;
  providerName?: string;
  driverName?: string;
  pickUpAddress?: string;
  dropOffAddress?: string;
  pickupDateFrom?: string;
  pickupDateTo?: string;
  todayDate?: string;
  tripLegExceptionBCs?: string[];
  excludingRideshareWillCalls?: boolean;
  isUnderDiscussion?: boolean;
} & Partial<PaginatedRequest> &
  Partial<SortedRequest>;

type TripLegRequestV2 = {
  page: number;
  pageSize?: number;
  sortModel?: SortModel;
  clientBC?: string;
  tripLegReferenceIDs?: string[];
  tripLegStatusBCs?: string[];
  providerAssigned?: boolean;
  transportationProviderID?: string[];
  isUnderDiscussion?: boolean;
  tripLegDiscussions?: { discussionReason: string }[];
  isException?: boolean;
  includeInvalid?: boolean;
  tripLegExceptionBC?: string[];
  isEscalated?: boolean;
  pickupStartDate?: string;
  pickupEndDate?: string;
  appointmentStartDate?: string;
  appointmentEndDate?: string;
  search?: string;
  includeExceptionLog?: boolean;
  includeTripLegStatusLogs?: boolean;
  excludeRideshareWillCalls?: boolean;
  searchAddress?: string;
  searchProviderName?: string;
  passengerCareLevelBCs?: string[];
  searchMemberName?: string;
  tripModeBCs?: string[];
};

export { TripLegSearchMenu };
export type { TripLegRequestV2, TripLegSearchRequest };
